// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StarRating_wrapper__2nK79"};